<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              Equipment Reliability
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 sm4 lg4>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.util"
              :rules="ruleMustBeFilledANDLessThan100"
              prepend-icon="hourglass_empty"
              hint="utilisation"
              suffix="%"
              persistent-hint
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4 lg4>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.avail"
              :rules="ruleMustBeFilledANDLessThan100"
              prepend-icon="schedule"
              hint="availability"
              suffix="%"
              persistent-hint
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4 lg4>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.rel"
              :rules="ruleMustBeFilledANDLessThan100"
              prepend-icon="running_with_errors"
              hint="reliability"
              suffix="%"
              persistent-hint
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 sm4 lg4>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.mttf"
              :rules="ruleMustBeFilledANDLessThan100"
              prepend-icon="update"
              hint="mean time to failure"
              persistent-hint
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4 lg4>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.mtbf"
              :rules="ruleMustBeFilledANDLessThan100"
              prepend-icon="timer"
              hint="mean time between failures"
              persistent-hint
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4 lg4>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.mttr"
              :rules="ruleMustBeFilledANDLessThan100"
              prepend-icon="work_history"
              hint="mean time to failure"
              persistent-hint
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.perf"
              :rules="ruleMustBeFilledANDLessThan100"
              prepend-icon="task"
              hint="performance standard"
              persistent-hint
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.design"
              :rules="ruleMustBeFilledANDLessThan100"
              prepend-icon="design_services"
              hint="design standard"
              persistent-hint
              ></v-text-field>
            </v-flex>
          </v-layout>
        </div>
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              Failure Modes and Reliability
            </div>
          </v-layout>
          <v-layout row wrap class="ml-3 mr-2 mt-4">
            <v-flex xs12>
              <v-textarea
              :change="updateFormChar()"
              :color="ui.textColor"
              :background-color="ui.btnColor"
              v-model="localForm.ops"
              :disabled="false"
              :outline="true"
              :rules="ruleMustBeNotUndefinedANDLessThan2000"
              hint="equipment reliability addditional comments"
              auto-grow
              persistent-hint
              ></v-textarea>
            </v-flex>
          </v-layout>
        </div>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import equipOptions from "@/data/options/mixins/equipOptions.js";
import listFunctions from "@/data/functions/mixins/listFunctions.js";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      localForm: {
        ops: "",
        rel: "",
        avail: "",
        util: "",
        mtbf: "",
        mttf: "",
        mttr: "",
        perf: "",
        design: ""
      },
      orgForm: {
        ops: "",
        rel: "",
        avail: "",
        util: "",
        mtbf: "",
        mttf: "",
        mttr: "",
        perf: "",
        design: ""
      }
    };
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.rel = this.getDetail.char.rel;
    this.localForm.avail = this.getDetail.char.avail;
    this.localForm.util = this.getDetail.char.util;
    this.localForm.mtbf = this.getDetail.char.mtbf;
    this.localForm.mttf = this.getDetail.char.mttf;
    this.localForm.mttr = this.getDetail.char.mttr;
    this.localForm.ops = this.getDetail.char.ops;
    this.localForm.perf = this.getDetail.char.perf;
    this.localForm.design = this.getDetail.char.design;

    this.orgForm.rel = this.getDetail.char.rel;
    this.orgForm.mtbf = this.getDetail.char.mtbf;
    this.orgForm.mttf = this.getDetail.char.mttf;
    this.orgForm.mttr = this.getDetail.char.mttr;
    this.orgForm.avail = this.getDetail.char.avail;
    this.orgForm.util = this.getDetail.char.util;
    this.orgForm.ops = this.getDetail.char.ops;
    this.orgForm.perf = this.getDetail.char.perf;
    this.orgForm.design = this.getDetail.char.design;
  },
  mixins: [
    docRevsModFunctions,
    ruleTextfield,
    apptheme,
    equipOptions,
    listFunctions
  ],
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getDetail",
      "getDetailChar",
      "getCurrentPage"
    ]),
  },
  methods: {
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-disable-next-line
      if (
        this.localForm.rel !== this.orgForm.rel &&
        this.localForm.rel !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.rel = this.localForm.rel;
        // basic
        char.rel = this.localForm.rel;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(2.31, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.avail !== this.orgForm.avail &&
        this.localForm.avail !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.avail = this.localForm.avail;
        // basic
        char.avail = this.localForm.avail;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(2.31, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.util !== this.orgForm.util &&
        this.localForm.util !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.util = this.localForm.util;
        // basic
        char.util = this.localForm.util;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(2.31, 3); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.mttf !== this.orgForm.mttf &&
        this.localForm.mttf !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.mttf = this.localForm.mttf;
        // basic
        char.mttf = this.localForm.mttf;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(2.31, 4); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.mtbf !== this.orgForm.mtbf &&
        this.localForm.mtbf !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.mtbf = this.localForm.mtbf;
        // basic
        char.mtbf = this.localForm.mtbf;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(2.31, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.mttr !== this.orgForm.mttr &&
        this.localForm.mttr !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.mttr = this.localForm.mttr;
        // basic
        char.mttr = this.localForm.mttr;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(2.31, 6); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.perf !== this.orgForm.perf &&
        this.localForm.perf !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.perf = this.localForm.perf;
        // basic
        char.perf = this.localForm.perf;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.71, 7); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.design !== this.orgForm.design &&
        this.localForm.design !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.design = this.localForm.design;
        // basic
        char.design = this.localForm.design;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(2.31, 8); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.ops !== this.orgForm.ops &&
        this.localForm.ops !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.ops = this.localForm.ops;
        // basic
        char.ops = this.localForm.ops;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.66, 10); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
